<template>
  <Container
    ref="container"
    class="">
    <div class="pointer-events-none relative z-20 flex h-full items-center text-white">
      <div class="w-full">
        <AnimatedText
          :copy="title"
          :visible="textVisible"
          tag="h2"
          class="max-w-4xl text-4xl leading-tight md:text-5xl md:leading-tight lg:text-6xl lg:leading-tight" />
      </div>
    </div>
    <div class="absolute top-0 -mx-10 -mt-[50%] flex items-end justify-between space-x-6 md:-mt-[30%] md:w-full">
      <div
        v-for="(img, i) in images.slice(0, 3)"
        :key="i"
        :class="[
          { 'w-[180px] lg:w-[284px]': i === 0 },
          { 'mb-20 w-[214px] lg:mt-[15vh] lg:w-[275px]': i === 1 },
          { 'mb-4 hidden w-[200px] md:block': i === 2 }
        ]"
        :style="{ transform: `translateY(${trigger * 25}vh)` }">
        <!-- Wrapper for @tailwindcss/aspect-ratio padding trick -->
        <div class="aspect-h-1 aspect-w-1">
          <NuxtImg
            :src="img.src"
            :alt="img.alt || ''"
            class="rounded-lg object-cover"
            sizes="xs:214px sm:214px md:214px lg:284px xl:284px xxl:284px"
            loading="lazy" />
        </div>
      </div>
    </div>
    <div class="absolute bottom-0 -mx-10 -mb-[50%] flex items-start justify-between space-x-6 md:-mb-[30%] md:w-full">
      <div
        v-for="(img, i) in images.slice(3, 6)"
        :key="i"
        :class="[
          { 'w-[230px] lg:w-[240px]': i === 0 },
          { 'mt-20 w-44 lg:mt-[10vh] lg:w-[245px]': i === 1 },
          { 'mt-12 hidden w-[275px] md:block lg:w-[405px]': i === 2 }
        ]"
        :style="{ transform: `translateY(-${trigger * 25}vh)` }">
        <!-- Wrapper for @tailwindcss/aspect-ratio padding trick -->
        <div class="aspect-h-1 aspect-w-1">
          <NuxtImg
            :src="img.src"
            :alt="img.alt || ''"
            class="rounded-lg object-cover"
            sizes="xs:230px sm:230px md:275px lg:405px xl:405px xxl:405px"
            loading="lazy" />
        </div>
      </div>
    </div>
  </Container>
</template>

<script setup lang="ts">
  import { ref, useTemplateRef, watch } from 'vue'

  import AnimatedText from './animated-text.vue'

  type SlidingImageProps = {
    trigger: number
    images: {
      src: string
      alt?: string
    }[]
    title: string
  }
  const props = defineProps<SlidingImageProps>()

  const container = useTemplateRef('container')
  const textVisible = ref(false)

  watch(
    () => props.trigger,
    trigger => {
      if (trigger > 1 || trigger < 0) {
        textVisible.value = false
      } else {
        textVisible.value = true
      }
    }
  )
</script>
